// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.centerbox {
  display: flex;
  height: 100vh;
  width: 100%;
  align-items: center;
  justify-content: center;
  align-self: center;
  background: rgb(255 255 255 / 79%);
  position: fixed;
  z-index: 999999;
  top: 0;
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
}
  .centerbox img{
    max-width:150px; 
  }
  .rotate {
    width: 55px;
    animation: rotation 2s infinite linear;
  }
  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }

  .loader {
    width: 48px;
    height: 48px;
    margin: auto;
    position: relative;
  }
  
  .loader:before {
    content: '';
    width: 48px;
    height: 5px;
    background: #c4c4c4;
    position: absolute;
    top: 60px;
    left: 0;
    border-radius: 50%;
    animation: shadow324 0.5s linear infinite;
    filter: blur(0px);
}
  
  .loader:after {
    content: '';
    width: 100%;
    height: 100%;
    background: #044080;
    background: linear-gradient(#802f92, #528ac7);
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 40px;
    animation: jump7456 0.5s linear infinite;
  }
  
  @keyframes jump7456 {
    15% {
      border-bottom-right-radius: px;
    }
  
    25% {
      transform: translateY(15px) rotate(22.5deg);
    }
  
    50% {
      transform: translateY(17px) scale(1, .9) rotate(45deg);
      border-bottom-right-radius: 40px;
    }
  
    75% {
      transform: translateY(4px) rotate(50.5deg);
    }
  
    100% {
      transform: translateY(4) rotate(90deg);
    }
  }
  
  @keyframes shadow324 {
  
    0%,
      100% {
      transform: scale(2, 2);
    }
  
    50% {
      transform: scale(2, );
    }
  }
`, "",{"version":3,"sources":["webpack://./src/components/Loading/Loading.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,MAAM;EACN,kCAA0B;UAA1B,0BAA0B;AAC5B;EACE;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,sCAAsC;EACxC;EACA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,yCAAyC;IACzC,iBAAiB;AACrB;;EAEE;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,6CAA6C;IAC7C,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,mBAAmB;IACnB,wCAAwC;EAC1C;;EAEA;IACE;MACE,8BAA8B;IAChC;;IAEA;MACE,2CAA2C;IAC7C;;IAEA;MACE,sDAAsD;MACtD,gCAAgC;IAClC;;IAEA;MACE,0CAA0C;IAC5C;;IAEA;MACE,sCAAsC;IACxC;EACF;;EAEA;;IAEE;;MAEE,sBAAsB;IACxB;;IAEA;MACE,qBAAqB;IACvB;EACF","sourcesContent":[".centerbox {\n  display: flex;\n  height: 100vh;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  align-self: center;\n  background: rgb(255 255 255 / 79%);\n  position: fixed;\n  z-index: 999999;\n  top: 0;\n  backdrop-filter: blur(5px);\n}\n  .centerbox img{\n    max-width:150px; \n  }\n  .rotate {\n    width: 55px;\n    animation: rotation 2s infinite linear;\n  }\n  @keyframes rotation {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(359deg);\n    }\n  }\n\n  .loader {\n    width: 48px;\n    height: 48px;\n    margin: auto;\n    position: relative;\n  }\n  \n  .loader:before {\n    content: '';\n    width: 48px;\n    height: 5px;\n    background: #c4c4c4;\n    position: absolute;\n    top: 60px;\n    left: 0;\n    border-radius: 50%;\n    animation: shadow324 0.5s linear infinite;\n    filter: blur(0px);\n}\n  \n  .loader:after {\n    content: '';\n    width: 100%;\n    height: 100%;\n    background: #044080;\n    background: linear-gradient(#802f92, #528ac7);\n    position: absolute;\n    top: 0;\n    left: 0;\n    border-radius: 40px;\n    animation: jump7456 0.5s linear infinite;\n  }\n  \n  @keyframes jump7456 {\n    15% {\n      border-bottom-right-radius: px;\n    }\n  \n    25% {\n      transform: translateY(15px) rotate(22.5deg);\n    }\n  \n    50% {\n      transform: translateY(17px) scale(1, .9) rotate(45deg);\n      border-bottom-right-radius: 40px;\n    }\n  \n    75% {\n      transform: translateY(4px) rotate(50.5deg);\n    }\n  \n    100% {\n      transform: translateY(4) rotate(90deg);\n    }\n  }\n  \n  @keyframes shadow324 {\n  \n    0%,\n      100% {\n      transform: scale(2, 2);\n    }\n  \n    50% {\n      transform: scale(2, );\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
